import Header from './Header';
import Learn from './Learn';
import LinksWrapper from './LinksWrapper';
import Reference from './Reference';
import ReferenceLink from './ReferenceLink';

export default {
  Header,
  Learn,
  LinksWrapper,
  Reference,
  ReferenceLink,
};
